import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card'; // Using Card for structure

const COOKIE_CONSENT_KEY = 'cookie_consent_status';

type ConsentStatus = 'accepted_all' | 'accepted_necessary' | null;

const CookieConsentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const consentStatus = localStorage.getItem(COOKIE_CONSENT_KEY) as ConsentStatus;
    // Show banner only if no choice has been made yet
    if (!consentStatus) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = (status: 'accepted_all' | 'accepted_necessary') => {
    localStorage.setItem(COOKIE_CONSENT_KEY, status);
    setIsVisible(false);
    // Optionally: Dispatch a custom event or trigger a callback if App.tsx needs immediate notification
    window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: { status } }));
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="max-w-screen-lg mx-auto shadow-lg">
        <CardContent className="p-4 md:p-6">
          <p className="text-sm text-gray-700">
            Vi använder cookies för att förbättra din upplevelse. Vissa är nödvändiga för att webbplatsen ska fungera, medan andra hjälper oss att förstå hur webbplatsen används så att vi kan förbättra den. Du kan läsa mer i vår{' '}
            <Link to="/integritetspolicy" className="text-minnestig-purple hover:underline">
              integritetspolicy
            </Link>.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row sm:justify-center gap-2 p-4 md:p-6 border-t"> {/* Changed justify-end to sm:justify-center */}
          <Button 
            variant="outline" 
            onClick={() => handleAccept('accepted_necessary')}
            className="w-full sm:w-auto"
          >
            Acceptera nödvändiga
          </Button>
          <Button 
            onClick={() => handleAccept('accepted_all')}
            className="w-full sm:w-auto bg-[#002B45] hover:bg-minnestig-purple text-white" // Match existing button style
          >
            Acceptera alla
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default CookieConsentBanner;
